import { useEffect } from "react";

/**
 * Injects <meta name="robots" content="noindex,nofollow"> into <head> while
 * the component is mounted, and restores the previous value on unmount.
 *
 * Use on auth-protected, utility, or duplicate-content pages so Googlebot
 * doesn't index them and report them as "Crawled — currently not indexed".
 */
export const useNoIndex = () => {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    const prev = meta?.getAttribute("content");
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex,nofollow");
    return () => {
      if (created) meta.remove();
      else if (prev !== undefined && prev !== null) meta.setAttribute("content", prev);
    };
  }, []);
};
